import React, { useState } from "react";
import { BiSearch } from "react-icons/bi";
import { IoAddCircle } from "react-icons/io5";
import { PiUserCircleBold, PiYoutubeLogoFill } from "react-icons/pi";
import { ThreeDots } from "react-loader-spinner";
import { useNavigate } from "react-router-dom";
import { GetParameter } from "src/assets/functions";
import { useNewExerciseMutation } from "src/assets/queries/exerciseTemplates/mutations";
import { Queries } from "src/assets/queries/exerciseTemplates/queries";
import { ExercisesIcon } from "src/assets/static/icons";
import * as Badge from "src/assets/svg/logo/badge.svg";
import Inputfield from "src/components/inputfield";
import SideListView from "src/components/SideListView";
import EmptyListInfo from "src/modules/protocols/components/EmptyListInfo";
import { FilterAndSortExc } from "../exercise";
import ExerciseDetails from "./ExerciseDetails";
import { List, ListingDiv } from "./styles";
// import { Container } from './styles';

const sliceSize = 30;

const NewExercises: React.FC = () => {
  const [slice, setSlice] = useState(sliceSize);

  const [search, setSearch] = useState("");
  const { data, isLoading, refetch } = Queries.useExercisesList();

  const newExerciseMutation = useNewExerciseMutation();

  const selected = GetParameter("id");

  const nav = useNavigate();

  const handleSetSearch = (s: string) => {
    setSearch(s);
    setSlice(sliceSize);
  };

  const threshold = 50; // Pixels antes do final da lista para carregar mais itens

  const handleScroll = (e: React.UIEvent<HTMLUListElement>) => {
    const { scrollTop, scrollHeight, clientHeight } = e.currentTarget;
    const isNearBottom = scrollHeight - scrollTop - clientHeight <= threshold;

    if (isNearBottom) {
      setSlice((prevSlice) => prevSlice + sliceSize);
    }
  };

  function Select(e: React.PointerEvent<HTMLLIElement>) {
    const id = e.currentTarget.getAttribute("data-id");

    nav(selected === id ? "/tools/exercises" : `/tools/exercises?id=${id}`);
  }

  const handleNewExercise = async () => {
    setSearch("");
    await newExerciseMutation.mutateAsync(
      "Novo Template - " +
        data
          ?.filter((e) => e.name.startsWith("Novo Template"))
          .reduce((a: number) => {
            return a + 1;
          }, 0),
    );
  };

  return (
    <SideListView
      list={
        <ListingDiv>
          <div className="flex items-center p-2">
            <ExercisesIcon
              style={{
                backgroundColor: "#ddd",
                borderRadius: "50%",
                padding: 10,
                marginRight: 10,
              }}
              color="#666"
              size={48}
            />
            <div className="flex-1">
              <h1 className="font-bold uppercase">Exercícios Template</h1>
            </div>
            <button
              onClick={handleNewExercise}
              className="flex items-center gap-2 rounded-full bg-primary-500 p-1.5 text-white"
            >
              <IoAddCircle color="white" />
              <p className="text-sm font-bold">CRIAR</p>
            </button>
          </div>

          <div className="p-2">
            <Inputfield
              icon={BiSearch}
              width={"100%"}
              radius="50px"
              onChangeText={handleSetSearch}
              inputProps={{
                placeholder: "Procurar Exercício...",
              }}
            />
          </div>

          <List onScroll={handleScroll}>
            {!data ? (
              <div className="m-auto flex h-full flex-1 items-center justify-center">
                {isLoading ? (
                  <ThreeDots
                    height="60"
                    width="60"
                    color="#000"
                    ariaLabel="three-dots-loading"
                    visible={true}
                  />
                ) : (
                  <EmptyListInfo
                    Icon={ExercisesIcon}
                    type={"Exercícios Template"}
                    hyperlink={
                      /*{
                  text: "Saiba mais:",
                }*/ undefined
                    }
                  />
                )}
              </div>
            ) : (
              FilterAndSortExc(data, search)
                .slice(0, slice)
                .map((e, i) => (
                  <li
                    key={`exc_${i}`}
                    className={`mb-2 flex h-10 flex-shrink-0 items-center justify-between rounded bg-white px-4 shadow ${
                      selected === e.id ? "bg-zinc-200" : ""
                    }`}
                    data-id={e.id}
                    onClick={Select}
                    draggable
                    onDragStart={(event) => {
                      event.dataTransfer.setData("exercise", JSON.stringify(e));
                    }}
                  >
                    <h4>{e.name}</h4>
                    <div className="flex items-center">
                      <div className="pr-3">
                        <PiYoutubeLogoFill
                          color={e.hasmedia ? "#444" : "#ccc"}
                          size={24}
                        />
                      </div>
                      {e.editable ? (
                        <PiUserCircleBold size={22} />
                      ) : (
                        <Badge.ReactComponent width={22} height={22} />
                      )}
                    </div>
                  </li>
                ))
            )}
          </List>
        </ListingDiv>
      }
      content={
        <div style={{ display: "flex", flex: 1, flexDirection: "column" }}>
          <ExerciseDetails id={selected} reloadList={refetch} />
        </div>
      }
      view={"CONTENT"}
    />
  );
};

export default NewExercises;
